import axios from "axios";
import * as actionType from "../../../constant/actionType";

const normalizeIds = (input, key) => {
  if (!Array.isArray(input)) {
    return [];
  }

  return input
    .map((item) => {
      if (item && typeof item === "object") {
        if (key && item[key] !== undefined && item[key] !== null) {
          return item[key];
        }
        if (item.value !== undefined && item.value !== null) {
          return item.value;
        }
        if (item.id !== undefined && item.id !== null) {
          return item.id;
        }
      }
      return item;
    })
    .filter(
      (value) => value !== undefined && value !== null && value !== ""
    );
};

export const GenerateProviderChecklistOverviewReport =
  (apiData) => async (dispatch) => {
    try {
      const clientOrgIds = normalizeIds(apiData?.client_org_ids, "organisation_id");
      const providerOrgIds = normalizeIds(apiData?.provider_org_ids, "provider_org_id");
      const checklistIds = normalizeIds(apiData?.checklist_ids, "checklist_id");
      const siteIds = normalizeIds(apiData?.site_ids, "site_id");

      const response = await axios({
        method: "get", // Change GET to POST
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
        },
        url: `${actionType.environment_url}/api/admin/provider/GenerateProviderChecklistOverviewReport`,
        params: {
          ...apiData,
          client_org_ids: JSON.stringify(clientOrgIds),
          provider_org_ids: JSON.stringify(providerOrgIds),
          checklist_ids: JSON.stringify(checklistIds),
          site_ids: JSON.stringify(siteIds),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };

export const TriggerProviderChecklistReport =
  (apiData) => async (dispatch) => {
    try {
      const clientOrgIds = normalizeIds(apiData?.client_org_ids, "organisation_id");
      const providerOrgIds = normalizeIds(apiData?.provider_org_ids, "provider_org_id");
      const checklistIds = normalizeIds(apiData?.checklist_ids, "checklist_id");
      const siteIds = normalizeIds(apiData?.site_ids, "site_id");

      const response = await axios({
        method: "post",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
        },
        url: `${actionType.environment_url}/api/admin/TriggerProviderChecklistReport`,
        data: {
          ...apiData,
          client_org_ids: JSON.stringify(clientOrgIds),
          provider_org_ids: JSON.stringify(providerOrgIds),
          checklist_ids: JSON.stringify(checklistIds),
          site_ids: JSON.stringify(siteIds),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };
